import { render } from "./AdaptiveTextBlockNew.vue?vue&type=template&id=406c6908&scoped=true"
import script from "./AdaptiveTextBlockNew.vue?vue&type=script&lang=js"
export * from "./AdaptiveTextBlockNew.vue?vue&type=script&lang=js"

import "./AdaptiveTextBlockNew.vue?vue&type=style&index=0&id=406c6908&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406c6908"]])

export default __exports__